import { get, post, postExFile } from "@utils/httpUtil";

// 分发元素关系列表
export function distributeElementRelationList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/distribute/elementRelationList`, data, config);
}

// 创建分发记录
export function distributeCreateDistributePlan(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/distribute/createDistributePlan`, data, config);
}

// 分页查询文章分发记录
export function distributeArticlePageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/distribute/pageList/article`, data, config);
}

// 导出文章详情分发记录
export function distributeRecordExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/distribute/pageList/article/export`, data, config);
}

// 取消分发记录
export function distributeCancelById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/distribute/cancelById`, data, config);
}

// 查询社区指定分享配置
export function shareConfigFindConfigByElement(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/shareConfig/findConfigByElement`, data, config);
}

// 保存或更新分享配置
export function shareConfigSaveConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/shareConfig/saveConfig`, data, config);
}

// 编辑分发记录
export function updateDistributePlan(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/distribute/updateDistributePlan`, data, config);
}
// 查询公众号二维码
export function findOfficialAccountQRCode(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/shareConfig/findOfficialAccountQRCode`, data, config);
}
// 查询小程序二维码
export function findMiniProgramQRCode(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/shareConfig/findMiniProgramQRCode`, data, config);
}
// 查询平台小程序二维码
export function findPlatformMiniProgramQRCode(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/shareConfig/findPlatformMiniProgramQRCode`, data, config);
}
